import script from './Icon.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function (_h,_vm) {var _c=_vm._c;return _c('i',_vm._g({class:[
        {
            icon: true,
            'icon--xxs' : _vm.props.size === 'xxs',
            'icon--xs' : _vm.props.size === 'xs',
            'icon--sm' : _vm.props.size === 'sm',
            'icon--md' : _vm.props.size === 'md',
            'icon--xl' : _vm.props.size === 'xl',
        },
        _vm.data.class,
        _vm.data.staticClass ]},_vm.listeners))};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-e798697a_0", { source: ".icon[data-v-e798697a]{display:inline-block;line-height:1;text-align:center;font-size:24px;width:24px;height:24px}.icon[data-v-e798697a]:not([class*=sds-icon-]):before{font-family:superbet-icons!important;font-style:normal;font-weight:400!important;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon--xxs[data-v-e798697a]{font-size:10px;width:10px;height:10px}.icon--xs[data-v-e798697a]{font-size:12px;width:12px;height:12px}.icon--sm[data-v-e798697a]{font-size:16px;width:16px;height:16px}.icon--md[data-v-e798697a]{font-size:20px;width:20px;height:20px}.icon--xl[data-v-e798697a]{font-size:32px;width:32px;height:32px}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-e798697a";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = true;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
